"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,3.47h-13A.5.5,0,0,0,10,4v11.5H9.55V6a.5.5,0,0,0-.5-.5H5a.5.5,0,0,0-.44.26L2.1,10.22l-2,2a.5.5,0,0,0-.15.35V18a.5.5,0,0,0,.5.5h1a3.51,3.51,0,1,1,6.92,0h7.08a3.51,3.51,0,1,1,6.92,0h1A.5.5,0,0,0,24,18V4a.5.5,0,0,0-.45-.55Zm-16,5.06H6.27L4.94,11.24a.5.5,0,0,1-.45.28.49.49,0,0,1-.22,0A.5.5,0,0,1,4,10.86l0-.06,1.49-3A.5.5,0,0,1,6,7.51h1.5a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "4.99",
    cy: "18.03",
    r: "2.51"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "19",
    cy: "18.03",
    r: "2.51"
  }));
};

exports["default"] = _default;